import Filter from 'components/ui/Filter';
import Spinner from 'components/ui/Spinner';
import StepNav from 'components/ui/StepNav';
import StepTitle from 'components/ui/StepTitle';
import Pagination from 'components/ui/Pagination';
import { useEffect, useState } from 'react';
import { getWinners } from 'services/realization.service';
import { categories, RealizationEvItem } from 'types/realization';
import CardEvaluated from 'components/ui/CardEvaluated';
import { FaExclamation } from 'react-icons/fa6';
import { useAuth } from 'context/AuthContext';
import { StageIds } from 'utils/constants';
import { useNavigate } from 'react-router';

const Winners = () => {
    const navigate = useNavigate();
    const { user, currentStep } = useAuth();
    const [loadingItens, setLoadingItens] = useState(false);
    const [categories, setCategories] = useState<categories[]>([]);
    const [realizations, setRealizations] = useState<RealizationEvItem[]>([]);
    const [filteredRealization, setFilteredRealization] = useState<RealizationEvItem[]>([]);

    const [filter, setFilter] = useState<{
        category?: string;
        searchTerm?: string;
        prefix?: number;
    }>({});

    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(12);

    const [currentItens, setCurrentItens] = useState<RealizationEvItem[]>([]);
    const [totalPages, setTotalPages] = useState(0);

    /*
    {(!user?.detail.isBoss || !user?.detail?.acessor?.vp) && currentStep?._id !== StageIds.STAGE_DOIS_AVALIACAO ? (
                            <NoEvaluation />
                        ) : (
    */

    useEffect(() => {
        //
        // if (user?.detail.isBoss || (user?.detail.acessor && user?.detail.acessor.vp)) {
        //     navigate('/wait');
        // } else {
            fetchData();
        // }
    }, [user]);

    const fetchData = async () => {
        try {
            setLoadingItens(true);
            const data = await getWinners();

            const items = data ? data.flatMap((item) => item.realizations) : [];

            let newCategories = data
                ? data.map((item) => {
                      return {
                          name: `${item.categoryName}(${item.realizations.filter((r) => r.realization.classificada === true).length || 0})`,
                          _id: item.categoryName
                      };
                  })
                : [];

            newCategories.unshift({
                name: `Todas (${items.length})`,
                _id: -1
            });

            setCategories(newCategories);

            setRealizations(items.sort((a, b) => (b.realization.classificada ? 1 : 0) - (a.realization.classificada ? 1 : 0)));
            setFilteredRealization(items);

            const indexOfLastItem = currentPage * perPage;
            const indexOfFirstItem = indexOfLastItem - perPage;
            const totalPages = Math.ceil(items.length / perPage);
            setTotalPages(totalPages);
        } catch (e) {
        } finally {
            setLoadingItens(false);
        }
    };

    useEffect(() => {
        const indexOfLastItem = currentPage * perPage;
        const indexOfFirstItem = indexOfLastItem - perPage;
        let newdata = filteredRealization.slice(indexOfFirstItem, indexOfLastItem);

        setCurrentItens(newdata);

        const totalPages = Math.ceil(filteredRealization.length / perPage);
        setTotalPages(totalPages);
    }, [currentPage, perPage, filteredRealization]);

    const filterData = (data: RealizationEvItem[], category?: string, title?: string, prefix?: number) => {
        console.log(category);
        let filteredData = data.filter((item) => {
            // const categoriaMatch = category ? item.categoria === category : true;
            const categoriaMatch = category && category !== '-1' ? item.categoria === category : true;

            const tituloMatch = title ? item.title.toLocaleLowerCase().includes(title) : true;
            const prefixMatch = prefix !== undefined ? String(item.prefixo).includes(String(prefix)) : true;

            return categoriaMatch && tituloMatch && prefixMatch;
        });

        console.log(filteredData);

        return filteredData;
    };

    useEffect(() => {
        let result = filterData(realizations, filter.category, filter.searchTerm?.toLocaleLowerCase(), filter.prefix);

        setFilteredRealization(result);
        setCurrentPage(1);
    }, [filter]);

    return (
      <>
        {loadingItens ? (
          <div className="flex items-start justify-center w-full h-screen">
            <div className="flex flex-col">
              <Spinner />
              <span className="text-center text-blue-bb">Carregando...</span>
            </div>
          </div>
        ) : (
          <>
            <>
              {currentStep?._id === StageIds.STAGE_DOIS_AVALIACAO ||
              currentStep?._id === StageIds.STAGE_TRES_AVALIACAO_DIRETOR || currentStep?._id === StageIds.STAGE_ENTREGA || StageIds.STAGE_AGUARDANDO_RESULTADO? (
                <>
                  <StepNav currentStep={4} activeSubStep={3} />
                  <StepTitle
                    title={"Resultado da etapa 2 de avaliação"}
                    description={
                      "Conheça as 41 iniciativas mais votadas pelos Vice-Presidentes e Presidenta e que participam da etapa final de votação do Prêmio BB 2025."
                    }
                  />
                </>
              ) : (
                <>
                  <StepNav currentStep={2} activeSubStep={2} />
                  <StepTitle
                    title={"Resultado da etapa 1 de avaliação"}
                    description={
                      "Acompanhe abaixo as realizações mais bem votadas pelos funcionários na primeira etapa de avaliação do Prêmio BB. De 24 de março a 3 de abril, será realizada a segunda etapa de avaliação."
                    }
                  />
                </>
              )}
            </>
            <div>
              <div className="flex items-end justify-end">
                <div className="w-full">
                  <Filter
                    categories={categories}
                    enableCategoryFilter={true}
                    enablePrefixFilter={true}
                    placeholderField={"Buscar por titulo de realizações"}
                    onChange={(key, value) => {
                      setFilter((prev) => ({ ...filter, [key]: value }));
                    }}
                  />
                </div>
              </div>
            </div>
            <>
              {currentItens.length === 0 ? (
                <>
                  <div className="flex items-center justify-center my-5">
                    <FaExclamation />
                    <p className="text-lg font-semibold text-gray-bb-1">
                      Não há realizações para esse filtro!
                    </p>
                  </div>
                </>
              ) : (
                <>
                  <div className="grid-cols-1 mx-4 md:grid md:mx-0 md:grid-cols-2 gap-7 content">
                    {currentItens.map(
                      (item: RealizationEvItem, index: number) => (
                        <CardEvaluated
                          data={item}
                          onlyResult={true}
                          key={index}
                        />
                      )
                    )}
                  </div>
                </>
              )}
            </>
            {totalPages > 0 && (
              <Pagination
                totalPages={totalPages}
                currentPage={currentPage}
                onPage={setCurrentPage}
              />
            )}
          </>
        )}
      </>
    );
};

export default Winners;
